export const focusRing = {
  outline: "2px solid",
  outlineColor: "brand.600",
  outlineOffset: "2px",
  boxShadow: "0 0 0 2px var(--chakra-colors-ink-light)",
} as const;
